export default __webpack_public_path__ + "static/media/carotaTtsIt_It60.71607e1a.mp3";